import { fetchResearchAuditHistory, FetchResearchAuditHistoryPayload } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ResearchAuditKeys = {
  all: ['researchAudit'] as const,
  history: (payload: FetchResearchAuditHistoryPayload) => [...ResearchAuditKeys.all, payload] as const,
}

export const useResearchAuditHistoryQuery = (payload: FetchResearchAuditHistoryPayload, enabled = true) => {
  return useQuery({
    queryKey: ResearchAuditKeys.history(payload),
    queryFn: () => fetchResearchAuditHistory(payload),
    enabled: enabled && Boolean(payload.SK_PESQUISA || payload.SK_PRODUTOS_PESQUISADOS),
  })
}
